<div class="auth-container">
  <img src="assets/images/vertical-logo.svg" alt="Logo" />
  <router-outlet />
</div>
